import { usePopupManager } from 'react-popup-manager';
import { OperatorCustomNotificationsConfirmationModalComponent } from 'modules/settings/pods/settings-operator-custom-notifications/components/operator-custom-notifications-confirmation-modal';
import {
    OperatorCustomNotificationAction,
    OperatorCustomNotificationRow,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';
import { useOperatorCustomNotificationsWrite } from 'modules/settings/pods/settings-operator-custom-notifications/service/hooks/use-operator-custom-notifications-write.hook';

export const useOperatorCustomNotificationsConfirmationModal = (onConfirmed: VoidFunction) => {
    const popupManager = usePopupManager();
    const { activate, deactivate, remove } = useOperatorCustomNotificationsWrite();

    const writeByAction: Record<OperatorCustomNotificationAction, (ids: string[]) => Promise<void>> = {
        activate,
        deactivate,
        delete: remove,
    };

    const showConfirmation = (
        action: OperatorCustomNotificationAction,
        notifications: OperatorCustomNotificationRow[]
    ) => {
        popupManager.open(OperatorCustomNotificationsConfirmationModalComponent, {
            action,
            notifications,
            onConfirm: () =>
                writeByAction[action](notifications.map((notification) => notification.id)).then(onConfirmed),
        });
    };

    return { showConfirmation };
};
